import React from "react";
import Center from "../../templates/Center";
import { workAtDark } from "../../Markup"

const Interviewing = () => {
  return (
    <div>
      <div className="Job-listing interviewing">
        <p>
          When you're interviewing at Dark, we want you to do your best. We aren't
          looking to catch you out with a “gotcha” or a crazy estimation question.
          We don't do whiteboarding, either. We want to hear about the work you're
          doing now, and the work you hope to do in the future. Even if Dark isn’t
          the right fit, we hope you (and we!) learn something through the
          process.
        </p>

        <p>
          To give you the most flexibility, we usually schedule through Calendly.
          We always let you decide between phone or video chat during early calls.
          If something in this format isn't going to work for you, let us know and
          we'll talk about ways to accommodate.
        </p>

        <h2>Introductory Conversation (45 min)</h2>

        <p>The first person you'll speak with is our engineering manager, Ian C.</p>

        <p>
          During this call we want to learn as much about you as possible. We're
          curious about how you learn, team environments that have worked well for
          you, and how you think about career changes. Since Dark is still in
          private alpha, we’ll also be sure to give you the full download on what
          we've been doing, and the current state of the product. Yes, you’ll get
          to see it! This call is as much for you as it is for us, and we’ll try to
          answer any questions you have.
        </p>

        <h2>Technical Skills Conversation (45 min)</h2>

        <p>
          Our second conversation is focused around your discipline. For
          engineering we'll get into your specific areas of expertise (frontend?
          backend? compilers? functional languages?), but we follow a similar
          format for all disciplines. We use these two conversations to design
          everything else about the interview process.
        </p>

        <h2>Technical Challenge (approximately 1 hour)</h2>

        <p>
          We know everyone works differently, so we offer a few options. We expect this to take about an hour,
          but schedule ninety minutes so you don't feel rushed. If you're doing it on your own time, we aren’t
          going to time you, but we don’t want this to expand into a half-day project, either.
        </p>

        <p>You can pick any of these:</p>

        <ul>
          <li>
            A scheduled interview during which we talk to you while you work through the
            challenge.
          </li>
          <li>
            Answering the same question on your own time as a take home challenge.
          </li>
          <li>
            Submitting a previous homework assignment from another interview.
          </li>
          <li>Presenting on a side project or previous homework to our team.</li>
          <li>
            Submitting another repository that you're proud of and would want us
            to evaluate like we would a technical challenge.
          </li>
        </ul>

        <h2>On site (all day)</h2>

        <p>
          We know interviewing is a big commitment! We don't believe in wasting
          time, especially if you have to take a day off work. We will pay you a
          one day contracting stipend of $500. Our goal is to get a holistic view
          of your experience so we can figure out where you fit in in our team.
          While you’re here, we'll talk about real challenges we’re facing at Dark.
          It’ll likely involve time pairing in our codebase, time using the
          product and sharing your thoughts, and some higher level discussions.
        </p>

        <h2>Reference Check</h2>

        <p>
          We ask for references when make an offer. That said, we
          assume the references will come back positively. The questions we ask
          are designed to help us figure out how to set up an environment so that
          you can succeed at Dark.
        </p>
      </div>
      <Center data={workAtDark} />
    </div>
  );
};

export default Interviewing;
